






















import {
  CourseContentState,
  Chapter,
  Course,
} from "@/store/course/types";
import ShowdownContainer from "@/components/ShowdownContainer.vue";

import Vue from "vue";
import iView from "iview";
import VueShowdown from "vue-showdown";

export default Vue.extend({
    name: "ContentViewer",
    components: {
      ShowdownContainer,
    },
    data: () => ({
      markdownContent: "",
      defaultSelected: 0, // Default selected chapter when the course content loads. Needs mounted code to load markdown.
    }),
    computed: {
      course(): Course {
        return (this.$store.state.course as CourseContentState).course;
      },
      chapters(): Chapter[] {
        return (this.$store.state.course as CourseContentState).chapters;
      }
    },
    methods: {
      selectChapter(index) {
        this.markdownContent = this.chapters[index].markdown;
      },
    },
    mounted() {
      this.selectChapter(this.defaultSelected);
    },
});
